import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-headcount-positions-data-grid',
  templateUrl: './headcount-positions-data-grid.component.html',
  styleUrls: ['./headcount-positions-data-grid.component.scss']
})
export class HeadcountPositionsDataGridComponent implements OnInit {
  @Input() public positions: any;

  public columns: any[] = [
    // { field: "employee['id']", subField:"id", title: "ID" },
    { field: "name", title: "name" },
    { field: "clientPositionId", title: "Client Position Id" },
    { field: "employmentType", subField:"text", title: "Employment Type" },
    { field: "workRotation", subField:"name", title: "Work Rotation" },
    { field: "startDate", title: "Start Date", type: 'date' },
    { field: "fixedTermEndDate", title: "Fixed Term End Date", type: 'date' },
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
